import { z } from "zod";
import { searchLanguageSchema } from "./search-language.js";
/**
 * Public auth discovery response (ADR-0029, .scratch/oauth2-ldap-auth/01).
 * Anonymous clients fetch this to learn which login paths the login view
 * offers without hardcoding: the OAuth2 mode + provider display name and
 * whether local password login is disabled. It also carries the global
 * `searchLanguage` (ADR-0036 decision 6) so the browser builds its keyword
 * index with the same tokenizer the server uses.
 */
export const authConfigSchema = z.object({
    oauth2: z.object({
        enabled: z.boolean(),
        mode: z.enum(["disabled", "button", "redirect"]),
        providerName: z.string(),
    }),
    /** Whether local password login is disabled (kill-switch). */
    localAuthDisabled: z.boolean(),
    /** Alias of localAuthDisabled, kept for the ADR-0029 `localDisabled` name. */
    localDisabled: z.boolean(),
    /** Global Orama search language (ADR-0036 decision 6); default `de`. */
    searchLanguage: searchLanguageSchema,
    /** Server-wide read-only demo (ADR-0045); default `false`. */
    demoMode: z.boolean().default(false),
});
/**
 * The authenticated identity both session responses carry. `email` is optional:
 * it is set by forward auth (`X-Forwarded-Email`) or a linked external identity.
 * The API's extra `ok: true` marker is not read by the client, so Zod strips it.
 */
export const sessionIdentitySchema = z.object({
    sub: z.string().min(1),
    displayName: z.string(),
    isOwner: z.boolean(),
    email: z.string().optional(),
});
/** `POST /api/auth/login` (ADR-0024): the logged-in identity. */
export const loginResponseSchema = sessionIdentitySchema;
/** `GET /api/me` (ticket 04): the same identity for a live session. */
export const meResponseSchema = sessionIdentitySchema;
//# sourceMappingURL=auth.js.map